var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5V14.1667M7.5 17.5V10.8333M12.5 17.5V12.5M17.5 17.5V9.16667M7.03278 4.63388C7.25899 4.86009 7.57149 5 7.91667 5C8.26184 5 8.57433 4.86009 8.80058 4.63388M7.03278 4.63388C6.80657 4.40767 6.66667 4.09517 6.66667 3.75C6.66667 3.05964 7.22631 2.5 7.91667 2.5C8.607 2.5 9.16667 3.05964 9.16667 3.75C9.16667 4.09517 9.02675 4.40767 8.80058 4.63388M7.03278 4.63388L4.63388 7.03278M8.80058 4.63388L11.1994 7.03278M4.63388 7.03278C4.40767 6.80657 4.09517 6.66667 3.75 6.66667C3.05964 6.66667 2.5 7.22631 2.5 7.91667C2.5 8.607 3.05964 9.16667 3.75 9.16667C4.44036 9.16667 5 8.607 5 7.91667C5 7.57149 4.86009 7.25899 4.63388 7.03278ZM11.1994 7.03278C10.9732 7.25899 10.8333 7.57149 10.8333 7.91667C10.8333 8.607 11.393 9.16667 12.0833 9.16667C12.7737 9.16667 13.3333 8.607 13.3333 7.91667C13.3333 7.57149 13.1934 7.25899 12.9672 7.03278M11.1994 7.03278C11.4257 6.80657 11.7382 6.66667 12.0833 6.66667C12.4285 6.66667 12.741 6.80657 12.9672 7.03278M12.9672 7.03278L15.3661 4.63388M15.3661 4.63388C15.5923 4.86009 15.9048 5 16.25 5C16.9403 5 17.5 4.44036 17.5 3.75C17.5 3.05964 16.9403 2.5 16.25 2.5C15.5597 2.5 15 3.05964 15 3.75C15 4.09517 15.1399 4.40767 15.3661 4.63388Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.ca727ac2c7c3d2ee8d03f1276c696d40.svg";
export { ForwardRef as ReactComponent };